module.exports = __webpack_public_path__ + "ce6f46fc5e72cce3c7543138c098c711.png";